/**
 * Centralized Icon Exports - MASTER FILE
 * This consolidation reduces bundle size by ensuring lucide-react is only imported once
 * ALL icons used in the codebase should be exported from this single file
 */

export {
  // Navigation & UI Controls
  Menu,
  X,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  ArrowRight,
  ExternalLink,
  MoreVertical,
  Search,
  Filter,
  
  // Time & Location
  Calendar,
  Clock,
  Globe,
  MapPin,
  
  // Communication
  Phone,
  Mail,
  MessageSquare,
  MessageCircle,
  Send,
  
  // Actions
  Share2,
  Download,
  Copy,
  Edit,
  Trash2,
  Plus,
  Minus,
  Check,
  CheckCircle,
  Play,
  LogIn,
  Loader2,
  RefreshCw,
  Maximize,
  Code,
  
  // Status & Alerts
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  
  // People & Organizations
  User,
  Users,
  Building,
  Briefcase,
  
  // Files & Content
  Home,
  FileText,
  FileCode,
  FileImage,
  Folder,
  Image,
  ImageIcon,
  Video,
  Music,
  Quote,
  BookOpen,
  Bookmark,
  PenTool,
  
  // Settings & Security
  Settings,
  Shield,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  
  // Social & Engagement
  Heart,
  Star,
  ThumbsUp,
  Award,
  Trophy,
  
  // Business & Analytics
  TrendingUp,
  TrendingDown,
  DollarSign,
  Gauge,
  CreditCard,
  BarChart,
  BarChart3,
  PieChart,
  Activity,
  Target,
  Zap,
  Rocket,
  Package,
  Database,
  Layers,
  
  // Social Media
  Facebook,
  Linkedin,
  Twitter,
  Youtube,
  
  // Device & Tech
  Smartphone,
  Monitor,
  Cpu,
  Bot,
  
  // Special/Custom
  QrCode,
  Palette,
  Diamond,
  GraduationCap,
  Lightbulb,
  Library,
  Megaphone,
  Coffee,
  Crown,
  
  // Type export
  type LucideIcon,
} from 'lucide-react';